import { setHighcharts } from '@highcharts/react'
import Highcharts, { AST } from 'highcharts'
import 'highcharts/modules/accessibility'
import 'highcharts/modules/exporting'
import 'highcharts/modules/offline-exporting'
import 'highcharts/highcharts-more'

AST.allowedReferences = [...AST.allowedReferences, 'data:']

setHighcharts(Highcharts)
